import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import InputElement         from 'react-input-mask';
import FieldError           from '../../Fragments/FieldError';

let Quote = require('../../Managers/Quote.js');
let Validation = require('../../Managers/Validation.js');

class YearMonth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            isValid: false,
            formattedDate: '',
            yearValue: null,
            activeValue: null,
        };
    }

    componentWillMount() {
        if (window.uorn(this.props.defaultValue)) {
            this.setState({
                years : null,
                months : null,
            });
        } else {
            this.setState({
                years : parseInt(this.props.defaultValue / 12),
                months : parseInt(this.props.defaultValue % 12),
            });
        }
    }

    handleValidation() {
        this.setTotalMonths();
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    setTotalMonths() {
        let months = parseInt(document.getElementById(this.props.fieldName + '_months').value);
        let years = parseInt(document.getElementById(this.props.fieldName + '_years').value);

        let totalCalculatedMonths;
        if (isNaN(years) && isNaN(months)) {
            totalCalculatedMonths = null;
        } else {
            totalCalculatedMonths = ((isNaN(years) ? 0 : years) * 12) + (isNaN(months) ? 0 : months);
        }

        let validation = Validation.validate(this.props.dataValidation, totalCalculatedMonths)[0];
        this.setState(Object.assign({}, validation, { activeValue: totalCalculatedMonths }), () => {
            this.props.isValid(validation.isValid);
        });

        if (validation.isValid) {
            if (this.props.callbackFunction) {
                this.props.callbackFunction(totalCalculatedMonths);
            }
        }

        Quote.set(this.props.storageKey, totalCalculatedMonths, this.props.source);
    }

    render() {
        return(
            <div className="question-input">
                <div className="row-2 constrained-row">
                    <div className="column small">
                        <span>Years</span>
                        <InputElement
                            mask="99"
                            onBlur={this.handleValidation.bind(this, 1)}
                            maskChar={null}
                            id={this.props.fieldName + '_years'}
                            defaultValue={this.state.years}
                        />
                    </div>
                    <div className="column small">
                        <span>Months</span>
                        <InputElement
                            mask="99"
                            onBlur={this.handleValidation.bind(this, 1)}
                            maskChar={null}
                            id={this.props.fieldName + '_months'}
                            defaultValue={this.state.months}
                        />

                        <input type="hidden" id={this.props.fieldName} />
                    </div>
                </div>
                {this.state.hasError === true ? <FieldError errors={this.state.errors} /> : null}
            </div>
        );
    }
}

YearMonth.propTypes = {
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string.isRequired,
    question:           PropTypes.string.isRequired,
    loadCachedValue:    PropTypes.bool.isRequired,
    dateType:           PropTypes.string.isRequired,
    dataValidation:     PropTypes.string,
    defaultValue:       PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    callbackFunction:   PropTypes.func,
    source:             PropTypes.string,
    isValid:            PropTypes.func,
    limitMonths:        PropTypes.bool,
};

YearMonth.defaultProps = {
    limitMonths: false,
};

export default YearMonth;


// WEBPACK FOOTER //
// ./src/components/Fields/Dates/YearMonth.js